import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yishoucang",
  "use": "icon-yishoucang-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yishoucang\"><path d=\"M505.6 793.6l-236.8 89.6c-6.4 0-12.8 0-19.2-6.4v-6.4l6.4-249.6v-6.4L108.8 435.2c-6.4-6.4-6.4-12.8 0-19.2h6.4L352 345.6s6.4 0 6.4-6.4l140.8-198.4c6.4-6.4 12.8-6.4 19.2 0l140.8 198.4 6.4 6.4L902.4 416c6.4 0 12.8 6.4 6.4 12.8v6.4L755.2 620.8v6.4l6.4 249.6c0 6.4-6.4 12.8-12.8 12.8h-6.4L505.6 800c6.4-6.4 6.4-6.4 0-6.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol